import React from "react";
import { useTrackVisibleRef } from "src/hooks/viewport";
import { Text } from "src/components/core/Text";
import {
  Box,
  BoxSection,
  Content,
  Icon,
  Section,
  CTASection,
  Keyword,
  MainTitle,
  Testimonial,
  Author,
  Quote,
  QuoteBlock,
} from "./BenefitsExpanded.styles";

import apple from "./images/apple.webp";
import lightbulb from "./images/lightbulb.webp";
import frenchFries from "./images/frenchFries.webp";
import YoYoMobile from "./images/yo-yo-mobile.gif";
import YoYoDesktop from "./images/yo-yo-desktop.gif";
import { FullWidth } from "../core/BodyLayout";
import { css } from "@emotion/react";
import i18n from "src/locales";

export const BenefitsExpanded = ({ children, keyword }) => {
  const buttonRef = useTrackVisibleRef("ScrolledLandingPageBottomCTA");

  const lpBenefitsRef = useTrackVisibleRef("ScrolledLandingPageBenefits");

  const lpWeightGraphRef = useTrackVisibleRef("ScrolledLandingPageWeightGraph");

  const lpTestimonialRef = useTrackVisibleRef("ScrolledLandingPageTestimonial");

  return (
    <Box>
      <FullWidth>
        {" "}
        <Keyword>
          {i18n.t(`belowFold:benefitsExpanded:${keyword}`)}
          <br />
          {i18n.t(`belowFold:benefitsExpanded:${keyword}WithNoom`)}
        </Keyword>
      </FullWidth>
      <MainTitle>{i18n.t("belowFold:benefitsExpanded:title")}</MainTitle>
      <BoxSection ref={lpBenefitsRef}>
        <Section>
          <Icon src={apple} />
          <Content>
            <Text i18nKey="belowFold:benefitsExpanded:content1" />
          </Content>
        </Section>
        <Section>
          <Icon src={lightbulb} />
          <Content>
            <Text i18nKey="belowFold:benefitsExpanded:content2" />
          </Content>
        </Section>
        <Section>
          <Icon src={frenchFries} />
          <Content>
            <Text i18nKey="belowFold:benefitsExpanded:content3" />
          </Content>
        </Section>
      </BoxSection>
      <FullWidth>
        <Testimonial>
          <picture
            css={css`
              align-self: center;
            `}
            ref={lpWeightGraphRef}
          >
            <source media="(min-width: 981px)" srcSet={YoYoDesktop} />
            <source media="(max-width: 981px)" srcSet={YoYoMobile} />
            <img
              src={YoYoMobile}
              loading="lazy"
              width="100%"
              alt={i18n.t("belowFold:benefitsExpanded:yoYoDietsVsNoom")}
            />
          </picture>
          <QuoteBlock>
            <Author ref={lpTestimonialRef}>
              {i18n.t("belowFold:benefitsExpanded:testimonialAuthor")}
            </Author>
            <Quote>{i18n.t("belowFold:benefitsExpanded:testimonial")}</Quote>
          </QuoteBlock>
        </Testimonial>
        <CTASection ref={buttonRef}>{children}</CTASection>
      </FullWidth>
    </Box>
  );
};
